import {
  AccordionItem,
  boxShadow,
  Divider,
  H3,
  mediaHelper,
  paletteHelper,
  radiusHelper,
  spacingHelper,
  Text,
  typographyHelper,
} from '@property.com.au/ui-kit';
import styled, { css } from 'styled-components';

export const DESKTOP_PROPERTY_ADDRESS_WIDTH = 315;
export const DESKTOP_PROPERTY_FACT_WIDTH = [175, 130, 90];

export const FactWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  > * {
    flex: 1;
  }
`;

export const MobileAccordionFactsTable = styled.div`
  margin: ${spacingHelper('large')} 0;
  ${mediaHelper('desktopMin')} {
    display: none;
  }
`;

export const DesktopAccordionFactsSubtitleWrapper = styled.div`
  ${mediaHelper('tabletMax')} {
    display: none;
  }
  display: flex;
  justify-content: space-between;
  flex-grow: 1;
  margin-left: ${spacingHelper('medium')};
`;

const accordionFactsSubtitleStylingHelper = ({ title }: { title?: string }) => {
  return css`
    ${typographyHelper('body02')}
    color: ${paletteHelper('textSecondary')};
    ${title === 'SOLD PRICE' &&
    css`
      ${typographyHelper('body02Bold')};
      color: ${paletteHelper('textPrimary')};
    `}
  `;
};

export const DesktopAccordionFactsSubtitle = styled.div<{ index: number; title: string }>`
  width: ${(props) => DESKTOP_PROPERTY_FACT_WIDTH[props.index]}px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  padding-right: ${spacingHelper('medium')};
  ${accordionFactsSubtitleStylingHelper}
`;

export const FactsTitle = styled(Text)`
  ${typographyHelper('overline')};
  color: ${paletteHelper('textSecondary')};
`;

export const FactsSubtitle = styled(Text)<{ title?: string }>`
  ${accordionFactsSubtitleStylingHelper}
`;

export const StyledAccordionItem = styled(AccordionItem)`
  background-color: ${paletteHelper('backgroundPrimaryHigh')};
  border: none;
  border-radius: ${radiusHelper('medium')};
  ${boxShadow.defaultBoxShadow};
  margin-bottom: ${spacingHelper('extraSmall')};

  .headerButton {
    border-radius: ${radiusHelper('medium')};
    /* override rules so that button color doesn't change on hover */

    &:hover {
      background-color: initial;
    }

    &:focus-visible {
      background-color: transparent;
      outline: solid calc(${spacingHelper('twoExtraSmall')} / 2);
    }
  }

  .content {
    padding-top: 0;
    ${mediaHelper('desktopMin')} {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      padding-top: ${spacingHelper('twoExtraSmall')};
    }
  }

  &:last-of-type {
    /* override accordion rule that last item has a bottom border */
    border-bottom: none;
  }
`;

export const TitleWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

export const PropertyAddressTitle = styled(H3)`
  ${typographyHelper('body02Bold')};
  ${mediaHelper('desktopMin')} {
    width: ${DESKTOP_PROPERTY_ADDRESS_WIDTH}px;
  }
`;

export const PropertyFeaturesWrapper = styled.div`
  ${mediaHelper('desktopMin')} {
    width: ${DESKTOP_PROPERTY_ADDRESS_WIDTH}px;
  }
  > :not(:first-child) {
    margin-top: ${spacingHelper('small')};
  }
`;

export const DesktopSoldDate = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: ${spacingHelper('extraSmall')};
  ${mediaHelper('tabletMax')} {
    display: none;
  }
`;

export const StyledDivider = styled(Divider)`
  margin: ${spacingHelper('extraSmall')} 0;
  border-color: ${paletteHelper('borderPrimary')};
`;

export const LinksWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;

  a {
    margin-top: ${spacingHelper('twoExtraSmall')};
    margin-bottom: ${spacingHelper('twoExtraSmall')};

    &:not(:last-child) {
      margin-right: ${spacingHelper('extraSmall')};
    }
  }

  ${mediaHelper('desktopMin')} {
    align-self: center;
    width: 258px;
    a {
      width: 100%;
    }
  }
`;

export const StyledPicture = styled.picture`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-bottom: ${spacingHelper('medium')};
  ${mediaHelper('tabletMin')} {
    justify-content: flex-start;
  }
  ${mediaHelper('desktopMin')} {
    width: ${DESKTOP_PROPERTY_FACT_WIDTH[0]}px;
    margin-bottom: 0;
  }
`;

export const StyledImage = styled.img`
  border-radius: ${radiusHelper('medium')};
  ${mediaHelper('tabletMax')} {
    height: 198px;
    object-fit: cover;
    width: 100%;
    max-width: 334px;
  }
  ${mediaHelper('desktopMin')} {
    height: 56px;
    width: 88px;
  }
`;
